// Metro bundler will automatically resolve:
// - index.ts (this file) for native platforms
// - index.web.ts for web platform

export { default } from './SourceViewer'
export type { SourceViewerProps } from './types'
